/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Law_P2Inputs */

const es_landing_law_p2 = /** @type {(inputs: Landing_Law_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ley exige que una gestora náutica autorizada firme el contrato y tramite el cambio de uso ante la autoridad marítima. No puedes hacerlo solo. `)
};

const gl_landing_law_p2 = /** @type {(inputs: Landing_Law_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lei esixe que unha xestora náutica autorizada asine o contrato e tramite o cambio de uso ante a autoridade marítima. Non podes facelo só. `)
};

const en_landing_law_p2 = /** @type {(inputs: Landing_Law_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The law requires an authorised nautical manager to sign the contract and process the change of use with the maritime authority. You cannot do it alone. `)
};

/**
* | output |
* | --- |
* | "The law requires an authorised nautical manager to sign the contract and process the change of use with the maritime authority. You cannot do it alone." |
*
* @param {Landing_Law_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_law_p2 = /** @type {((inputs?: Landing_Law_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Law_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_law_p2(inputs)
	if (locale === "en") return en_landing_law_p2(inputs)
	return es_landing_law_p2(inputs)
});